/**
 * Returns the first day of the week
 */
export const getWeekStartDay = (date?: string) => {
  const dateObj = date ? new Date(date) : new Date();
  const dayOfWeek = dateObj.getDay();
  const diff = dateObj.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
  const firstDay = new Date(dateObj.setDate(diff));
  return firstDay;
};

/**
 * Return the list of next seven days
 */
export const getNextSevenDays = (startDate: Date) => {
  const days: Date[] = [];
  for (let i = 0; i < 7; i++) {
    const nextDay = new Date(startDate);
    nextDay.setDate(nextDay.getDate() + i);
    nextDay.setHours(0, 0, 0, 0);
    days.push(nextDay);
  }
  return days;
};

/**
 * Return the list of previous seven days
 */
export const getPrevSevenDays = (startDate: Date) => {
  const days: Date[] = [];
  for (let i = 0; i < 7; i++) {
    const prevDay = new Date(startDate);
    prevDay.setDate(prevDay.getDate() - i - 1);
    prevDay.setHours(0, 0, 0, 0);
    days.push(prevDay);
  }
  return days.reverse();
};

/**
 * Return the list of months names from the list of dates
 */
export const getMonthsNames = (dates: Date[]) => {
  const monthsNames: string[] = [];
  for (const date of dates) {
    const monthName = `${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`;
    if (!monthsNames.includes(monthName)) {
      monthsNames.push(monthName);
    }
  }
  return monthsNames.join(' - ');
};

/**
 * Returns date formatted as YYYY-MM-DD
 */
export const formatDate = (date: Date) => `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
